import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";

import { ButtonCreate } from "../../../ui/ButtonCreate/ButtonCreate";
import css from "./TitleMenuClientsComponent.module.css";
import { clientsActions } from "../../../store/slices/clients-slices";

const SEARCH_PLACEHOLDERS = {
  id: "Search by ID",
  name: "Search by name",
  address: "Search by address",
  phoneNumber: "Search by phone number",
};

const TitleMenuClientsComponent = ({ setIsOpen, setIsOpenClientsImport }) => {
  const dispatch = useDispatch();
  const { handleSubmit, register, setValue, watch } = useForm({
    defaultValues: {
      clientsSearch: "",
      searchField: "name",
    },
  });
  const searchField = watch("searchField");

  useEffect(() => {
    setValue("clientsSearch", "");
    setValue("searchField", "name");
    dispatch(clientsActions.setSearchField("name"));
  }, [setValue, dispatch]);

  const handleOnSubmit = useCallback(
    (data) => {
      dispatch(clientsActions.setSearchField(data.searchField));
      dispatch(clientsActions.setSearchQuery(data.clientsSearch ?? ""));
    },
    [dispatch]
  );

  const handleClick = () => {
    setIsOpen(true);
  };

  return (
    <section className={css.wrap}>
      <div className={css.blockBtn}>
        <ButtonCreate onClick={handleClick} />

        <button
          type="button"
          className={css.importBtn}
          onClick={() => setIsOpenClientsImport(true)}
        >
          import
        </button>
      </div>

      <form onChange={handleSubmit(handleOnSubmit)} className={css.form}>
        <select
          {...register("searchField")}
          className={css.fieldSelect}
          aria-label="Search field"
        >
          <option value="name">Name</option>
          <option value="id">ID</option>
          <option value="address">Address</option>
          <option value="phoneNumber">Phone number</option>
        </select>
        <input
          type="text"
          {...register("clientsSearch")}
          placeholder={
            SEARCH_PLACEHOLDERS[searchField] ?? SEARCH_PLACEHOLDERS.name
          }
        />
      </form>
    </section>
  );
};

export { TitleMenuClientsComponent };
